import { render, staticRenderFns } from "./PartnerManage.vue?vue&type=template&id=51c49dfc&scoped=true"
import script from "./PartnerManage.vue?vue&type=script&lang=js"
export * from "./PartnerManage.vue?vue&type=script&lang=js"
import style0 from "./PartnerManage.vue?vue&type=style&index=0&id=51c49dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c49dfc",
  null
  
)

export default component.exports